//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {

    },
    data () {
        return {
            model:{},
            total:0,
            search:"",
            content:"",
        }
    },
    created(){
            var searchContent=this.$route.query.searchContent;
           if(searchContent && searchContent.length>0){
                this.model.searchContent=searchContent;
                this.getMenu();
           }
    },
    methods: {
        goBack(){
            // this.$router.go(-1)
            this.$router.push({
                path : '/doc/index',
                query : {}
            })
        },
        getMenu(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mdoc/getList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                        for(var i=0;i<res.body.rows.length;i++){
                            if(res.body.rows[i].contentText != undefined){
                            this.content = res.body.rows[i].contentText;
                          res.body.rows[i].contentText=this.showContent(this.content);
                            }

                       } 
                         this.search= res.body.rows;
                         this.total= res.body.total;
                    }    
                },function(res){
            });
        },
        showContent(content) {
        var mess=this.model.searchContent;
        if( mess==""){
            return content;
        }
        //找到元素起始位置
        
        if(content.indexOf(mess)!=(-1)){
            if(content.length>=45){

                if(content.indexOf(mess)<(45-mess.length)){

                    return content
                }else{

                    var start1=content.indexOf(mess);
                    // var start=46-parseInt(start1/2)
                    var start=start1-20;
                    return  (content.substring(start,content.length));
                }
           }else{
                return content;
            }
       }else{
            return content;
        }

    },
    brightenKeyword(val, keyword) {
        if(val != undefined){
        val = val + '';
        if (val.indexOf(keyword) !== -1 && keyword !== '') {
            
        return val.replace(keyword, '<span style="color: red">' + keyword + '</span>')
        } else {
            return val
            }
        }
        },
    goDetail(docId,docTypeId){
         this.$router.push({path:'detail',query:{'docTypeId':docTypeId,searchContent:this.model.searchContent}});
    }
    }
}



// WEBPACK FOOTER //
// ./src/views/doc/docSearch.vue